import api from '@api';
import { all, call, put, takeEvery } from 'redux-saga/effects';
import { ProductType } from '../../types/product';
import { getProductsListFetch } from '../productsList/reducer';
import {
    patchMultipleProductsFetchFailure,
    patchMultipleProductsFetchSuccess,
    patchProductFetchFailure,
    patchProductFetchSuccess
} from './reducer';
import { getProductsGridFetch } from '../productsGrid/reducer';
import { GridRequestType } from '../../types/table';


const patchProductFetchRequest = async (claim: ProductType, data: ProductType) => {
    const res = await api('patch', `api/secure/products/${claim.ID}`, data);
    return res.data;
};

function* patchProductFetch(action: { type: string; payload: { product: ProductType; data: ProductType } }) {
    const { product, data } = action.payload;

    try {
        yield call((): any => patchProductFetchRequest(product, data));
        yield put(patchProductFetchSuccess());
    } catch (error) {
        yield put(patchProductFetchFailure({ error }));
    }
}

export function* patchProductFetchWatch() {
    yield takeEvery('productsUpdate/patchProductFetch', patchProductFetch);
}

function* patchMultipleProductsFetch(action: { type: string; payload: { products: ProductType[]; data: ProductType, allProviders: boolean, params: GridRequestType } }) {
    const { products, data } = action.payload;
    try {
        for (let i = 0; i < products.length; i += 10) {
            const batch = products.slice(i, i + 10);
            yield all(
                batch.map((product) =>
                    call(patchProductFetch, { type: 'productsUpdate/patchProductFetch', payload: { product: product, data } })
                )
            );
        }
        yield put(patchMultipleProductsFetchSuccess());
        yield put(getProductsGridFetch(undefined));
    } catch (error) {
        yield put(patchMultipleProductsFetchFailure({ error }));
        yield put(getProductsGridFetch(undefined));
    }
}

export function* patchMultipleProductsFetchWatch() {
    yield takeEvery('productsUpdate/patchMultipleProductsFetch', patchMultipleProductsFetch);
}
